import { createRouter, createWebHistory } from "vue-router";
import { ROUTE } from "@/router/routeDefinitions.ts";
import { RoleName } from "@/constants";

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: ROUTE.PUBLIC_STARTPAGE.PATH,
            name: ROUTE.PUBLIC_STARTPAGE.NAME,
            component: () => import("@/views/PublicViews/StartPage/StartPage.vue"),
        },
        {
            path: ROUTE.PUBLIC_ERROR_PAGE.PATH,
            name: ROUTE.PUBLIC_ERROR_PAGE.NAME,
            component: () => import("@/views/PublicViews/ErrorPage/ErrorPage.vue"),
        },
        {
            path: ROUTE.RESTRICTED_AREA.PATH,
            name: ROUTE.RESTRICTED_AREA.NAME,
            redirect: { name: ROUTE.SHIPMENT_LIST.NAME },
            component: () => import("@/views/RestrictedViews/RestrictedViews.vue"),
            children: [
                {
                    path: ROUTE.SHIPMENT_LIST.PATH,
                    name: ROUTE.SHIPMENT_LIST.NAME,
                    component: () => import("@/views/RestrictedViews/ShipmentList/ShipmentList.vue")
                },
                {
                    path: ROUTE.DASHBOARD.PATH,
                    name: ROUTE.DASHBOARD.NAME,
                    meta: { hasAnyPermission: [RoleName.GrafanaAccessViewer] },
                    component: () => import("@/views/RestrictedViews/GrafanaDashboard/GrafanaDashboard.vue")
                }
            ]
        },
        {
            path: ROUTE.AUTHENTICATION_CALLBACK.PATH,
            name: ROUTE.AUTHENTICATION_CALLBACK.NAME,
            component: () => import("@/views/Authentication/AuthenticationCallback.vue"),
        },
        {
            path: ROUTE.PUBLIC_PAGE_NOT_ALLOWED.PATH,
            name: ROUTE.PUBLIC_PAGE_NOT_ALLOWED.NAME,
            component: () => import("@/views/PublicViews/PageNotAllowed/PageNotAllowed.vue"),
        },
        {
            path: "/:pathMatch(.*)*",
            name: ROUTE.PUBLIC_PAGE_NOT_FOUND.NAME,
            component: () => import("@/views/PublicViews/PageNotFound/PageNotFound.vue"),
        }
    ],
});

router.onError((err, to) => {
    if (err?.message?.includes?.("Failed to fetch dynamically imported module")) {
        if (localStorage.getItem("vuetify:dynamic-reload")) {
            console.error("Dynamic import error, reloading page did not fix it", err);
        } else {
            console.log("Reloading page to fix dynamic import error");
            localStorage.setItem("vuetify:dynamic-reload", "true");
            location.assign(to.fullPath);
        }
    } else {
        console.error(err);
    }
});

router.isReady().then(() => {
    localStorage.removeItem("vuetify:dynamic-reload");
});

export default router;
